"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderCatalogsFormValidationSchema = void 0;
const Yup = __importStar(require("yup"));
const libs_utils_1 = require("@hotelplan/libs.utils");
const supergraph_api_1 = require("@hotelplan/supergraph-api");
exports.OrderCatalogsFormValidationSchema = Yup.object({
    salutation: Yup.string()
        .required('forms:errors.salutation.required')
        .oneOf(Object.values(supergraph_api_1.FdrSalutation)),
    firstName: Yup.string()
        .min(2, 'forms:errors.firstName.tooShort')
        .max(50, 'forms:errors.firstName.tooLong')
        .matches(libs_utils_1.NAME_REGEX, 'forms:errors.name.lettersOnly')
        .required('forms:errors.firstName.required'),
    lastName: Yup.string()
        .min(2, 'forms:errors.lastName.tooShort')
        .max(50, 'forms:errors.lastName.tooLong')
        .matches(libs_utils_1.NAME_REGEX, 'forms:errors.name.lettersOnly')
        .required('forms:errors.lastName.required'),
    email: Yup.string()
        .email('forms:errors.email.invalid')
        .matches(/\.[a-z]{2,}$/i, 'forms:errors.email.invalid')
        .required('forms:errors.email.required'),
    road: Yup.string()
        .min(2, 'forms:errors.street.tooShort')
        .max(50, 'forms:errors.street.tooLong')
        .matches(/[a-zA-Zà-öù-žß]{2,}/i, 'forms:errors.street.invalid')
        .required('forms:errors.street.required'),
    zip: Yup.string()
        .matches(/^[0-9]{4}$/, 'forms:errors.zip.invalid')
        .required('forms:errors.zip.required'),
    city: Yup.string()
        .min(2)
        .max(50)
        .matches(libs_utils_1.LETTERS_AND_WHITESPACE_REGEX, 'forms:errors.name.lettersOnly')
        .required('forms:errors.city.required'),
    country: Yup.string()
        .min(2, 'forms:errors.country.tooShort')
        .max(50, 'forms:errors.country.tooLong')
        .required('forms:errors.country.required'),
    phone: Yup.string().matches(libs_utils_1.PHONE_REGEX, 'forms:errors.phone.invalid'),
    recaptchaToken: Yup.string().required('forms:errors.required'),
    subscribe: Yup.boolean(),
});
//# sourceMappingURL=fdr-catalogs-order-form.validation.js.map